import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo1 from '../../assets/common/new-era-logo.png';
import Logo2 from '../../assets/common/new-era-logo-white.png';
import { GrClose } from "react-icons/gr";


const MobileHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const closeMenu = () => {setIsMobileMenuOpen(false);};
  const isActive = (path) => location.pathname === path;

  return ( <>
  
  <header className="py-6 px-8">
  <div className="flex justify-between items-center">

  <div>
  <Link to="/"><img src={Logo1} alt="Main Logo" className="h-8"/></Link></div>
      
  <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
  className="flex flex-col justify-between h-auto w-6 text-white">
  <span className="block w-full h-[2.5px] mb-[6px] bg-blue"></span>
  <span className="block w-full h-[2.5px] mb-[6px] bg-blue"></span>
  <span className="block w-full h-[2.5px] bg-blue"></span></button>
  </div></header>

  <div className={`fixed top-0 left-0 bg-blue text-white w-full h-full z-50 transform
  ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300`}>
  

  <div className="flex items-center justify-between px-8 py-6">
  <Link to="/"><img src={Logo2} alt="Side Logo" className="h-8"/></Link>
  <button onClick={closeMenu} className="flex items-center">
  <GrClose className="h-[19.5px] w-[19.5px]"/></button></div>
  
  <hr className="border-white mx-8 border-t-[0.5px] shadow-[0_0_10px_#314258,0_0_20px_#314258]" />

  <nav className="mt-6 px-8 font-bold space-y-6 text-lg">
  <Link to="/" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>Home</Link>
  
  <Link to="/about" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/about') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>About</Link>

  <Link to="/projects" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/projects') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>Projects</Link>

<Link to="/partnerships" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/partnerships') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>Partnerships</Link>
  
  <Link to="/expansion" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/expansion') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>Expansion</Link>
  
  <Link to="/news" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/news') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>News</Link>
  
  <Link to="/contact" className={`block transition-all duration-[400ms] ease-in-out
  ${isActive('/contact') ? 'text-white' : 'text-gray-500'} hover:text-white hover:underline`}
  onClick={closeMenu}>Contact Us</Link>
  </nav></div>
    </>);};

export default MobileHeader;